<template>
  <!----session details popup start------>
  <div
    class="modal fade session_details_popup"
    id="session-details"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18.03"
              height="18.031"
              viewBox="0 0 18.03 18.031"
            >
              <path
                id="close.svg"
                fill="#242432"
                d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                transform="translate(-1412 -516)"
              />
            </svg>
          </button>
          <div class="session-details p-4">
            <div class="sponsors-box-hld">
              <div class="media align-items-center">
                <span class="logo-hld"></span>
                <div class="media-body">
                  <!-----top headding-31.07.2020---->
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="pt-1 pl-1">
                        <h3 class="mt-0">{{ Title }}</h3>
                        <p class="time mb-0">
                          {{ StartTimeLabel }} - {{ EndTimeLabel }}
                        </p>
                      </div>
                    </div>
                    <!--live pannel icon--->
                    <div class="col-lg-6">
                      <div
                        v-if="!IsPlayerPopup"
                        class="
                          d-flex
                          calender-icon-hld
                          align-items-center
                          mt-2
                          session-live-des
                        "
                      >
                        <ul
                          class="d-flex align-items-center justify-content-end"
                          id="dvBroadcast"
                        >
                          <li
                            v-show="AllowAddRemoveMyAgenda && IsMyAgenda"
                            :id="'liRemoveFromMyAgenda_' + SessionID"
                          >
                            <button
                              @click="removeFromMyAgenda(SessionID)"
                              :id="'removeFromMyAgenda_' + SessionID"
                              class="remove-agenda-button d-none1"
                            >
                              {{ $t("sessions.removeagenda") }}
                            </button>
                          </li>
                          <li
                            v-show="AllowAddRemoveMyAgenda && !IsMyAgenda"
                            :id="'liAddToMyAgenda_' + SessionID"
                          >
                            <button
                              @click="addToMyAgenda(SessionID)"
                              :id="'addToMyAgenda_' + SessionID"
                              class="add-agenda-button d-none1"
                            >
                              {{ $t("sessions.addagenda") }}
                            </button>
                          </li>
                          <li v-if="SessionTypeID == 1">
                            <a
                              v-if="IsLive"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn ' + LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              title=""
                              href="javascript:void(0)"
                              data-original-title="On-Demand"
                              @click="startSession(SessionID)"
                            >
                              <label
                                ><img
                                  src="../assets/Images/on-demand-white.svg"
                                />
                              </label>

                              <!-- <span>{{ $t("sessions.joinOnDemand") }}</span> -->

                              <span>WATCH NOW</span>
                            </a>
                            <a
                              v-else
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn ' + LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              title=""
                              href="javascript:void(0)"
                              data-original-title="On-Demand"
                            >
                              <label
                                ><img
                                  src="../assets/Images/on-demand-white.svg"
                                />
                              </label>

                              <!-- <span>{{ $t("sessions.joinOnDemand") }}</span> -->
                              <span>WATCH NOW</span>
                            </a>
                          </li>
                          <li v-if="SessionTypeID == 2">
                            <a
                              v-if="IsLive"
                              data-toggle="tooltip"
                              data-placement="top"
                              data-tag="live"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn ' + LinkClass
                              "
                              title=""
                              data-original-title="Live Stream"
                              @click="startSession(SessionID)"
                            >
                              <label
                                ><img
                                  src="../assets/Images/live-stream-white.svg"
                                />
                              </label>
                              <!-- <span>{{
                                $t("sessions.joinLiveStream")
                              }}</span> -->
                              <span>WATCH NOW</span>
                            </a>
                            <a
                              v-else
                              data-toggle="tooltip"
                              data-placement="top"
                              data-tag="live"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn ' + LinkClass
                              "
                              title=""
                              data-original-title="Live Stream"
                            >
                              <label
                                ><img
                                  src="../assets/Images/live-stream-white.svg"
                                />
                              </label>

                              <!-- <span>{{
                                $t("sessions.joinLiveStream")
                              }}</span> -->

                              <span>WATCH NOW</span>
                            </a>
                          </li>
                          <li v-if="SessionTypeID == 3">
                            <a
                              v-if="IsLive"
                              href="javascript:void(0)"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn ' + LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              title=""
                              data-original-title="Live Panel"
                              @click="startSession(SessionID)"
                            >
                              <label>
                                <img
                                  src="../assets/Images/live-panel-white.svg"
                              /></label>
                              <!-- <span>{{ $t("sessions.joinLivePanel") }}</span> -->
                              <span>{{
                                HasBackStageAccess
                                  ? "ENTER BACKSTAGE"
                                  : "JOIN NOW"
                              }}</span>
                            </a>
                            <a
                              v-else
                              href="javascript:void(0)"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn ' + LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              title=""
                              data-original-title="Live Panel"
                            >
                              <label>
                                <img
                                  src="../assets/Images/live-panel-white.svg"
                              /></label>
                              <!-- <span>{{ $t("sessions.joinLivePanel") }}</span> -->
                              <span>JOIN NOW</span>
                            </a>
                          </li>
                          <li v-if="SessionTypeID == 4">
                            <!-- <a
                              v-bind:href="IsLive?'/roundtable/' + TopicId:'#'"
                              v-bind:class="'icon-bookmark1 bmark-pupupbtn '+LinkClass"
                              data-toggle="tooltip"
                              data-placement="top"
                              title=""
                              data-original-title="Round Table"
                            >
                              <label>
                                <img src="../assets/Images/round-table.svg"
                              /></label>
                              <span>Round Table</span></a
                            > -->
                            <a
                              @click="startRTSession(SessionID, IsLive)"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn ' + LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              title=""
                              data-original-title="Round Table"
                            >
                              <label>
                                <img
                                  src="../assets/Images/round-table-white.svg"
                              /></label>
                              <!-- <span>{{
                                $t("sessions.joinRoundTable")
                              }}</span> -->
                              <span>JOIN NOW</span>
                            </a>
                          </li>
                          <li v-if="SessionTypeID == 5">
                            <a
                              v-if="IsLive"
                              href="javascript:void(0)"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn session-link in-person-session-details ' +
                                LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              title=""
                              :data-original-title="InPersonLabel"
                              @click="startSession(SessionID)"
                            >
                              <label class="session-type-icon">
                                <!--<img src="../assets/Images/in-person.svg"/>-->
                                <img v-bind:src="InPersonIcon" />
                              </label>
                              <!--<span>{{ $t("sessions.joinInPerson") }}</span>-->
                              <span>{{ InPersonLabel }}</span></a
                            >
                            <a
                              v-else
                              href="javascript:void(0)"
                              :class="
                                'icon-bookmark1 bmark-pupupbtn session-link in-person-session-details ' +
                                LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              title=""
                              :data-original-title="InPersonLabel"
                            >
                              <label class="session-type-icon">
                                <!--<img src="../assets/Images/in-person.svg"/>-->
                                <img :src="InPersonIcon" />
                              </label>
                              <!--<span>{{ $t("sessions.joinInPerson") }}</span>-->
                              <span>{{ InPersonLabel }}</span></a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>

                    <!----->
                    <!------add to calender-icon-------->
                    <!--v-if="IsUpcoming"-->
                    <div v-if="!IsPlayerPopup" class="col-md-12">
                      <div
                        v-if="!IsPlayerPopup"
                        :class="
                          EndTime > parseInt(new Date().getTime() / 1000)
                            ? 'd-flex calender-icon-hld align-items-center my-2 pb-3'
                            : 'd-flex calender-icon-hld align-items-center my-2 pb-3 disabled'
                        "
                      >
                        <ul
                          v-if="
                            EndTime > parseInt(new Date().getTime() / 1000)
                          "
                          class="d-flex align-items-center"
                        >
                          <li class="pl-0">
                            <a
                              v-bind:href="AddToGoogleCalendar"
                              target="_blank"
                            >
                              <span>
                                <img
                                  src="../assets/Images/icons/google-icon.svg"
                                  alt="google-icon"
                                />
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              v-bind:href="AddToOutlookCalendar"
                              target="_blank"
                            >
                              <span>
                                <img
                                  src="../assets/Images/icons/outlook.svg"
                                  alt="outlook-icon"
                                />
                              </span>
                            </a>
                          </li>
                          <li>{{ $t("sessions.addtoCalendar") }}</li>
                        </ul>
                        <ul v-else class="d-flex align-items-center">
                          <li class="pl-0">
                            <a href="javascript:void(0)">
                              <span>
                                <img
                                  src="../assets/Images/icons/google-icon.svg"
                                  alt="google-icon"
                                />
                              </span>
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0)">
                              <span>
                                <img
                                  src="../assets/Images/icons/outlook.svg"
                                  alt="outlook-icon"
                                />
                              </span>
                            </a>
                          </li>
                          <li>{{ $t("sessions.addtoCalendar") }}</li>
                        </ul>
                        <!--
<add-to-calendar
title="VueConf"
location="WROCŁAW, POLAND"
:start="new Date()"
:end="new Date((new Date).setDate((new Date).getDate() + 1))"
details="The first Official Vue.js Conference in the world!"
inline-template
>
<div>
<google-calendar id="google-calendar">
<i class="fa fa-google"></i> Add to Google calendar
</google-calendar>

<microsoft-calendar id="microsoft-calendar">
<i class="fa fa-windows"></i> Add to Microsoft live calendar
</microsoft-calendar>

<office365-calendar id="office365-calendar">
<i class="fa fa-windows"></i> Add to Office365 outlook calendar
</office365-calendar>
</div>
</add-to-calendar>-->
                      </div>
                    </div>
                    <!----add to calender-end--------->
                  </div>
                  <!---------------->
                  <div class="session-details-option py-3 d-none">
                    <ul>
                      <li><v-btn depressed color="#eff3f7" width="153px" height="50px" class="option-single-butn"><span class="mr-2"><img src="../assets/Images/icons/qna.svg"/></span> QNA</v-btn></li>
                      <li><v-btn depressed color="#eff3f7" width="153px" height="50px" class="option-single-butn"><span class="mr-2"><img src="../assets/Images/icons/check-in.svg"/></span> CHECK IN</v-btn></li>
                      <li><v-btn depressed color="#eff3f7" width="153px" height="50px" class="option-single-butn"><span class="mr-2"><img src="../assets/Images/icons/poll.svg"/></span> POLL</v-btn></li>
                      <li><v-btn depressed color="#eff3f7" width="153px" height="50px" class="option-single-butn"><span class="mr-2"><img src="../assets/Images/icons/rating.svg"/></span> RATING</v-btn></li>
                    </ul>
                  </div>
                  <p v-html="DescriptionShort"></p>
                  <p v-html="Description" class="mt-4"></p>
                </div>
              </div>
            </div>
            <!--Session details option hld-->
            
            <!--Session details option hld-->
            <!-----spakers list***-->
            <div class="speakers-box-hld" v-show="SpeakerLength > 0">
              <!-- <h3>Speakers</h3> -->
              <h2 class="sessions-hdr-next">
                {{ SpeakerLength }} {{ $t("sessions.speaker") }}(s)
              </h2>
              <div class="row mt-4">
                <div
                  class="col-lg-3 col-md-6 mob-pt-0"
                  v-for="host in MappedHosts"
                  :key="host.AttendeeId"
                  v-show="!host.HideInList"
                >
                  <div
                    class="media align-items-center clsclick"
                    data-toggle="modal"
                    data-target="#myModal2"
                    v-on:click="openModal(host.AttendeeId)"
                  >
                    <span class="logo-hld">
                      <img
                        v-if="host.ProfilePictureURL != ''"
                        v-bind:src="getCDNUrl(host.ProfilePictureURL)"
                        @error="host.ProfilePictureURL = ''"
                      />
                      <span
                        v-else-if="host.NameInitial != ''"
                        class="speaker-name-initial"
                        >{{ host.NameInitial }}</span
                      >
                      <img v-else v-bind:src="avatarImageUrl" />
                    </span>
                    <div class="media-body ml-3">
                      <h4>
                        {{ host.Name }}
                        <span>[HOST]</span>
                      </h4>
                      <h5>{{ host.Company }}</h5>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-3 col-md-6"
                  v-for="speakers in MappedSpeakers"
                  :key="speakers.AttendeeId"
                  v-show="!IsHost(speakers.AttendeeId) && !speakers.HideInList"
                >
                  <div
                    class="media align-items-center clsclick"
                    data-toggle="modal"
                    data-target="#myModal2"
                    v-on:click="openModal(speakers.AttendeeId)"
                  >
                    <div class="logo-hld">
                      <img
                        v-if="speakers.ProfilePictureURL != ''"
                        v-bind:src="getCDNUrl(speakers.ProfilePictureURL)"
                        @error="speakers.ProfilePictureURL = ''"
                      />
                      <span
                        v-else-if="speakers.NameInitial != ''"
                        class="speaker-name-initial"
                        >{{ speakers.NameInitial }}</span
                      >
                      <img v-else v-bind:src="avatarImageUrl" />
                    </div>
                    <div class="media-body ml-3">
                      <h4>
                        {{ speakers.Name }}
                      </h4>
                      <h5>{{ speakers.Company }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-----spakers list end***-->
            <!---rosource-listing--->
            <div
              class="rosource-listing-wrapper mt-1"
              v-show="Resources.length > 0"
            >
              <h3>Resources</h3>
              <div class="row">
                <div
                  class="col-md-4"
                  v-for="resource in Resources"
                  v-bind:key="resource"
                >
                  <div class="rosource-listing">
                    <div class="d-flex justify-content-between">
                      <div class="media align-items-center">
                        <span class="logo-hld">
                          <svg
                            version="1.1"
                            id="Layer_1"
                            width="45"
                            fill="#242432"
                            height="45"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 512 512"
                            style="enable-background: new 0 0 512 512"
                            xml:space="preserve"
                          >
                            <g>
                              <g>
                                <g>
                                  <path
                                    d="M444.875,109.792L338.208,3.125c-2-2-4.708-3.125-7.542-3.125h-224C83.135,0,64,19.135,64,42.667v426.667	C64,492.865,83.135,512,106.667,512h298.667C428.865,512,448,492.865,448,469.333v-352	C448,114.5,446.875,111.792,444.875,109.792z M341.333,36.417l70.25,70.25h-48.917c-11.76,0-21.333-9.573-21.333-21.333V36.417z M426.667,469.333c0,11.76-9.573,21.333-21.333,21.333H106.667c-11.76,0-21.333-9.573-21.333-21.333V42.667	c0-11.76,9.573-21.333,21.333-21.333H320v64C320,108.865,339.135,128,362.667,128h64V469.333z"
                                  />
                                  <path
                                    d="M310.385,313.135c-9.875-7.771-19.26-15.76-25.51-22.01c-8.125-8.125-15.365-16-21.656-23.5	c9.813-30.323,14.115-45.958,14.115-54.292c0-35.406-12.792-42.667-32-42.667c-14.594,0-32,7.583-32,43.688	c0,15.917,8.719,35.24,26,57.698c-4.229,12.906-9.198,27.792-14.781,44.573c-2.688,8.052-5.604,15.51-8.688,22.406	c-2.51,1.115-4.948,2.25-7.302,3.427c-8.479,4.24-16.531,8.052-24,11.594C150.5,370.177,128,380.844,128,401.906	c0,15.292,16.615,24.76,32,24.76c19.833,0,49.781-26.49,71.656-71.115c22.708-8.958,50.938-15.594,73.219-19.75	c17.854,13.729,37.573,26.865,47.125,26.865c26.448,0,32-15.292,32-28.115c0-25.219-28.813-25.219-42.667-25.219	C337.031,309.333,325.49,310.604,310.385,313.135z M160,405.333c-6.094,0-10.219-2.875-10.667-3.427	c0-7.563,22.552-18.25,44.365-28.583c1.385-0.656,2.792-1.313,4.219-1.99C181.896,394.563,166.052,405.333,160,405.333z M234.667,214.354c0-22.354,6.938-22.354,10.667-22.354c7.542,0,10.667,0,10.667,21.333c0,4.5-3,15.75-8.49,33.313	C239.135,233.75,234.667,222.698,234.667,214.354z M242.844,329c0.667-1.854,1.313-3.729,1.938-5.625	c3.958-11.875,7.521-22.542,10.698-32.146c4.427,4.875,9.198,9.865,14.313,14.979c2,2,6.958,6.5,13.563,12.135	C270.208,321.208,256.219,324.76,242.844,329z M362.667,334.552c0,4.792,0,6.781-9.896,6.844	c-2.906-0.625-9.625-4.583-17.917-10.229c3.01-0.333,5.229-0.5,6.479-0.5C357.094,330.667,361.563,332.208,362.667,334.552z"
                                  />
                                </g>
                              </g>
                            </g>
                          </svg>
                        </span>
                        <div class="media-body ml-3">
                          <a v-bind:href="resource" target="_blank">
                            <h4 style="word-break: break-all">
                              {{ getFileName(resource) }}
                            </h4>
                          </a>
                        </div>
                      </div>
                      <a
                        style="display: none"
                        class="no-bookmark themeiconbg"
                        title
                        data-placement="left"
                        data-toggle="tooltip"
                        href="javascript:void(0);"
                        data-original-title="Bookmark"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="42px"
                          height="42px"
                        >
                          <path
                            fill-rule="evenodd"
                            stroke-width="2px"
                            stroke="rgb(102, 102, 112)"
                            fill-opacity="0"
                            fill="rgb(3, 97, 159)"
                            d="M21.000,5.000 C29.837,5.000 37.000,12.163 37.000,21.000 C37.000,29.837 29.837,37.000 21.000,37.000 C12.163,37.000 5.000,29.837 5.000,21.000 C5.000,12.163 12.163,5.000 21.000,5.000 Z"
                          />
                          <path
                            fill-rule="evenodd"
                            fill="rgb(102, 102, 112)"
                            d="M20.989,12.000 L23.866,17.144 L29.717,18.252 L25.644,22.538 L26.383,28.366 L20.989,25.872 L15.595,28.366 L16.334,22.538 L12.261,18.252 L18.112,17.144 L20.989,12.000 "
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!------>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!----session details popup end------>
</template>

<style>
.clsclick:hover {
  cursor: pointer;
}

.calender-icon-hld ul {
  padding: 0;
  margin: 0;
  width: 100%;
}
.calender-icon-hld ul li {
  display: inline-block;
  padding: 0 0 0 12px;
  font-size: 16px;
}
.calender-icon-hld ul li span {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #cecedf;
  display: flex;
  align-items: center;
  justify-content: center;
}
.calender-icon-hld ul li span:hover {
  cursor: pointer;
  background: #f2f2f2;
}
.calender-icon-hld ul li span img {
  width: 22px;
  height: 25px;
}

.session-details .session-live-des #dvBroadcast a {
  padding: 10px 15px 10px 0;
  border-radius: 6px;
  flex-direction: row;
  justify-content: center;
  background: #19a883;
  display: flex;
  align-items: center;
}
.session-details .session-live-des #dvBroadcast a label img {
  padding: 0 15px;
  border-right: 1px solid rgba(255, 255, 255, 0.4);
}
.session-details .session-live-des #dvBroadcast a span {
  font-weight: 500;
  color: #ffffff;
  padding-left: 15px;
}
.session-details .session-live-des #dvBroadcast li label img {
  filter: brightness(0) invert(1);
}
.session-details .session-live-des #dvBroadcast a span,
.session-details .session-live-des #dvBroadcast li label {
  margin: 0;
  height: auto;
}
.session-details .calender-icon-hld ul li span:hover {
  background: transparent;
}
.modal .session-details .speakers-box-hld .media .logo-hld {
  overflow: hidden;
}
.modal .session-details .speakers-box-hld .media .logo-hld img {
  height: auto;
  width: auto;
}
button.add-agenda-button {
  border: 1px solid #000;
  background: #fff url(../assets/Images/icons/add-to-agenda.svg) no-repeat left
    14px center;
  font-size: 14px;
  font-weight: 400;
  color: #000;
  padding: 12px 16px 12px 45px;
  border-radius: 5px;
}
button.remove-agenda-button {
  border: 1px solid #000;
  background: #fff url(../assets/Images/icons/remove-from-agenda.svg) no-repeat
    left 14px center;
  font-size: 14px;
  font-weight: 400;
  color: #000;
  padding: 12px 16px 12px 45px;
  border-radius: 5px;
}
</style>
<script>
//import { stream } from "xlsx/types";
//import AddToCalendar from "vue-add-to-calendar";
import db from "../components/firebaseInit";
//import firebase from "firebase";
import jQuery from "jquery";
let $ = jQuery;
import common from "@/common";

var self;
export default {
  data() {
    return {
      attendeeData: [],
      avatarImageUrl:
        "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2Favatar.jpg?alt=media",
    };
  },
  components: {
    //AddToCalendar
  },
  props: {
    IsPlayerPopup: Boolean,
    SessionID: String,
    SessionTypeID: Number,
    IsLive: Boolean,
    LinkClass: String,
    HasBackStageAccess: Boolean,
    TopicId: String,
    Title: String,
    Location: String,
    DescriptionShort: String,
    StartTimeLabel: String,
    EndTimeLabel: String,
    StartTime: Number,
    EndTime: Number,
    TimeZone: String,
    Description: String,
    MappedHosts: Array,
    MappedSpeakers: Array,
    SpeakerLength: Number,
    IsUpcoming: Boolean,
    Resources: Array,
    IsMyAgenda: Boolean,
    AllowAddRemoveMyAgenda: Boolean,
    InPersonLabel: String,
    InPersonIcon: String,
    InPersonURL: String,
  },
  computed: {
    AddToGoogleCalendar() {
      //debugger;
      var dtFrom = this.getCalendarDateTime(this.StartTime, "google");
      var dtTo = this.getCalendarDateTime(this.EndTime, "google");
      //alert(location.host.toLowerCase());
      //debugger;
      return (
        "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=" +
        dtFrom +
        "/" +
        dtTo +
        "&text=" +
        this.Title +
        "&details=" +
        this.DescriptionShort.replace("&", "and") +
        "<br/>To Login Go To " +
        location.origin.toLowerCase() +
        "&location=" +
        this.Location
      );
      //return (
      //  "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=" +
      //  dtFrom +
      //  "/" +
      //  dtTo +
      //  "&text=" +
      //  this.Title +
      //  "&details=" +
      //  this.DescriptionShort.replace("&", "and") +
      //  "<br /><br />To Login <a href='" +
      //  location.origin.toLowerCase() +
      //  "'>Click Here</a>" +
      //  "&location=" +
      //  this.Location
      //);
    },
    AddToOutlookCalendar() {
      //let tz = this.TimeZone;
      //if (tz == "US/Eastern") {
      //  tz = "America/New_York";
      //}
      let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      var dtFrom = this.getCalendarDateTime(this.StartTime, "outlook");
      var dtTo = this.getCalendarDateTime(this.EndTime, "outlook");
      //alert(location.host.toLowerCase());
      //debugger;
      let body =
        this.DescriptionShort +
        "<br/>To Login Go To " +
        location.origin.toLowerCase();
      var linkUrl =
        "start=" +
        dtFrom +
        "&end=" +
        dtTo +
        "&title=" +
        this.Title +
        "&description=" +
        body +
        "&location=&timezone=" +
        tz.replace("/", "%2F") +
        "&service=outlook";
      //"&startdt=" +
      //  "12%2F18%2F2020+09%3A00+AM" +
      //  "&enddt=" +
      //  "12%2F18%2F2020+11%3A00+AM" +
      //  "&uid=1a45242b-5205-4f37-815a-84ab74990640&allday=false&path=/calendar/action/compose";
      //alert(linkUrl);
      linkUrl =
        "https://www.addevent.com/dir/?client=amFHciuoCzziVYGDHmDp105401&" +
        linkUrl;
      //var linkUrl =
      //  "https://outlook.live.com/calendar/0/deeplink/compose?rru=addevent" +
      //  "&subject=" +
      //  this.Title +
      //  "&body=" +
      //  this.DescriptionShort.replace("&", "and") +
      //  "<br /><br />To Login <a href='" +
      //  location.origin.toLowerCase() +
      //  "'>Click Here</a>" +
      //  "&startdt=" +
      //  dtFrom +
      //  "&enddt=" +
      //  dtTo +
      //  "&uid=1a45242b-5205-4f37-815a-84ab74990640&allday=false&path=/calendar/action/compose";
      //alert(linkUrl);
      return linkUrl;
    },
    AddToOutlookCalendar1() {
      var dtFrom = this.getCalendarDateTime(this.StartTime, "outlook");
      var dtTo = this.getCalendarDateTime(this.EndTime, "outlook");
      //alert(location.host.toLowerCase());
      //debugger;
      let body =
        this.DescriptionShort.replace("&", "and") +
        "<br/>To Login Go To " +
        location.origin.toLowerCase();
      body = body.replace(/ /g, "&nbsp;");
      body = encodeURIComponent(body);
      var linkUrl =
        "rru=addevent" +
        "&subject=" +
        this.Title.replace(/ /g, "_") +
        "&body=" +
        body;
      "&startdt=" +
        dtFrom +
        "&enddt=" +
        dtTo +
        "&uid=1a45242b-5205-4f37-815a-84ab74990640&allday=false&path=/calendar/action/compose&timezone=America%2FLos_Angeles";
      //alert(linkUrl);
      linkUrl =
        "https://outlook.live.com/calendar/0/deeplink/compose?" + linkUrl;
      //var linkUrl =
      //  "https://outlook.live.com/calendar/0/deeplink/compose?rru=addevent" +
      //  "&subject=" +
      //  this.Title +
      //  "&body=" +
      //  this.DescriptionShort.replace("&", "and") +
      //  "<br /><br />To Login <a href='" +
      //  location.origin.toLowerCase() +
      //  "'>Click Here</a>" +
      //  "&startdt=" +
      //  dtFrom +
      //  "&enddt=" +
      //  dtTo +
      //  "&uid=1a45242b-5205-4f37-815a-84ab74990640&allday=false&path=/calendar/action/compose";
      //alert(linkUrl);
      return linkUrl;
    },
  },
  mounted() {
    self = this;
  },
  //beforeUpdate() {
  //  alert();
  //  this.MappedSpeakers.sort(function (a, b) {
  //    let aName = a.Name.trim().toLowerCase();
  //    let bName = b.Name.trim().toLowerCase();
  //    if (aName < bName) {
  //      return -1;
  //    }
  //    if (aName > bName) {
  //      return 1;
  //    }
  //    return 0;
  //  });
  //},
  methods: {
    IsHost(attendeeId) {
      let flag = false;
      let hosts = this.MappedHosts.filter(function (item) {
        return item.AttendeeId == attendeeId;
      });
      if (hosts.length > 0) {
        flag = true;
      }
      return flag;
    },
    startRTSession(SessionID, IsLive) {
      if (IsLive) {
        self.startSession(SessionID);
      }
    },
    startSession(sessionId) {
      self.$emit("onStartSession", sessionId);
    },
    addToMyAgenda(sessionId) {
      self.$emit("addToMyAgenda", sessionId);
    },
    removeFromMyAgenda(sessionId) {
      self.$emit("removeFromMyAgenda", sessionId);
    },
    //AddToGoogleCalendar() {
    //  debugger;
    //  //var strUrl =
    //  //  "https:%2F%2Fcalendar.google.co=m%2Fcalendar%2Frender%3Faction=3DTEMPLATE%26dates=3D20200726T123000Z%2F2020=0726T133000Z%26text=3DSid%2527s%2BVirtual%2BCocktail%2BParty%26details=3DVi=rtual%2BCocktail%2BParty%2Bis%2Ba%2Bspeed%2Bnetworking%2Bformat%2Bthat%2Ben=ables%2Beveryone%2Bto%2Bconnect%2Bwith%2Beach%2Bother%2Bthrough%2Bmultiple%=2Brounds%2Bof%2Bfive-minute%252C%2Bone-on-one%2Bconversations.%2BYou%2Bcan%=2Bcatch%2Bup%2Bor%2Bdiscuss%2Ba%2Bparticular%2Btopic%2Bwith%2Beach%2Bother.=%26location=3Dhttps%253A%252F%252Fapp.runtheworld.today%252Finvitation%252F=4956/1/010101737e64805c-59c65b51-184b-4b5e-b127-62e29bd74b1f-000000/SmCqny4=n3sf197Z6e5ZXU7uq0dg=3D172";
    //  alert("SessionID:" + this.SessionID);
    //  alert("Title:" + this.Title);
    //},
    openModal: function (attendeeid) {
      // console.log(Resources);
      self.attendeeData = [];
      //debugger;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var listRef = db
        .collection(obj.eventcollectionname)
        .doc("SpeakerList")
        .collection("Speakers")
        .where("SpeakerId", "==", attendeeid);
      listRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          self.attendeeData.push({
            id: doc.id,
            Name:
              (doc.data().FirstName == undefined ? "" : doc.data().FirstName) +
              " " +
              (doc.data().LastName == undefined ? "" : doc.data().LastName),
            Email: doc.data().Email,
            Image: doc.data().ProfilePictureURL,
            Company: doc.data().Company,
            Designation: doc.data().Designation,
            Profile: doc.data().Profile == undefined ? "" : doc.data().Profile,
            Resources: doc.data().Resources ? doc.data().Resources : [],
            SocialLinks: doc.data().SocialLinks ? doc.data().SocialLinks : [],
            Initials: common.getInitials(
              (doc.data().FirstName == undefined ? "" : doc.data().FirstName) +
                " " +
                (doc.data().LastName == undefined ? "" : doc.data().LastName)
            ),
            //ShowSearch: self.ShowSearch
            Phone: doc.data().Phone,
          });
        });
        //debugger;
        document.getElementById("spnSpkEmail").innerText =
          self.attendeeData[0].Email;
        document.getElementById("spnSpkPhone").innerText =
          self.attendeeData[0].Phone;

        document.getElementById("Session").innerText = "";
        if (
          self.attendeeData[0].Image != null &&
          self.attendeeData[0].Image != ""
        ) {
          $("#imgModalSpeakers").attr("src", self.attendeeData[0].Image);
          document.getElementById("dvImgeHldText").innerText = "";
          $("#dvImgeHldText").hide();
          $("#imgModalSpeakers").show();
          $("#dvImgeHld").show();
        } else {
          $("#imgModalSpeakers").attr("src", "");
          $("#imgModalSpeakers").hide();

          document.getElementById("dvImgeHldText").innerText =
            self.attendeeData[0].Initials;
          $("#dvImgeHldText").show();
          $("#dvImgeHld").hide();
        }
        document.getElementById("modalName").innerText =
          self.attendeeData[0].Name;
        document.getElementById("modalCompany").innerText =
          self.attendeeData[0].Company;
        document.getElementById("modalTtile").innerText =
          self.attendeeData[0].Designation;
        document.getElementById("modalProfile").innerHTML =
          self.attendeeData[0].Profile;
        //--------------Resource collection-------------------------------------------------------------
        document.getElementById("SpkModalResource").innerText = "";
        if (self.attendeeData[0].Resources != undefined) {
          if (self.attendeeData[0].Resources.length > 0) {
            self.attendeeData[0].Resources.forEach((resource) => {
              if (resource != "") {
                $("#SpkModalResource").append(
                  " <div class='session-tab-innerBox p-3 mb-2'><h5 class><a href=" +
                    resource +
                    '" target="_blank">' +
                    self.getFileName(resource) +
                    "</h5></div>"
                );
              }
            });
            document.getElementById("ulTabList").children[2].style.display =
              "block";
          } else {
            document.getElementById("ulTabList").children[2].style.display =
              "none";
          }
        } else {
          document.getElementById("ulTabList").children[2].style.display =
            "none";
        }
        //-------------Session collection for Speaker-------------------------------------
        var arrSession = [];

        var listRef = db
          .collection(obj.eventcollectionname)
          .doc("SessionList")
          .collection("Sessions");
        listRef
          .orderBy("StartDate", "desc")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var mappedSpeakers = doc.data().MappedSpeakers;

              $.each(mappedSpeakers, function (index, value) {
                if (value.AttendeeId != undefined) {
                  if (value.AttendeeId == attendeeid) {
                    var obj = new Object();
                    obj.Name =
                      doc.data().Name == undefined ? "" : doc.data().Name;
                    obj.StartDate =
                      doc.data().StartDate == undefined
                        ? ""
                        : doc.data().StartDate;
                    obj.EndDate =
                      doc.data().EndDate == undefined ? "" : doc.data().EndDate;
                    arrSession.push(obj);
                  }
                }
              });
            });
            var dtt;
            var dttEnd;
            $.each(arrSession, function (index, value) {
              var AtartdateString = "";
              var endDateString = "";

              const monthNamesShort = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
              ];
              //----------------------------------------------------------------------------------
              dtt = new Date(value.StartDate.seconds * 1000);
              var minutes = dtt.getMinutes();
              minutes = minutes == 0 ? "00" : minutes;
              if (minutes != "00" && parseInt(minutes) < 10) {
                minutes = "0" + minutes;
              }

              AtartdateString +=
                monthNamesShort[dtt.getMonth()] +
                " " +
                dtt.getDate() +
                " " +
                dtt.getHours() +
                ":" +
                minutes;
              //----------------------------------------------------------------------------------
              dttEnd = new Date(value.EndDate.seconds * 1000);
              var endMins = dttEnd.getMinutes();
              var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

              endMins = endMins == 0 ? "00" : endMins;
              if (endMins != "00" && parseInt(endMins) < 10) {
                endMins = "0" + endMins;
              }
              endDateString +=
                monthNamesShort[dttEnd.getMonth()] +
                " " +
                dttEnd.getDate() +
                " " +
                dttEnd.getHours() +
                ":" +
                endMins;
              //----------------------------------------------------------------------------------
              $("#Session").append(
                " <div class='session-tab-innerBox p-3 mb-2'><h5 class>" +
                  value.Name +
                  "</h5><p class='event-date'>" +
                  AtartdateString +
                  " to " +
                  endDateString +
                  " " +
                  timeZone +
                  "</p></div>"
              );
            });
          });
        //------------Session collection for Speaker ENDS-----------------------------------------------------------------------
        //-----------Social Linnks Starts---------------------------------------------------------------------
        //console.log("Facebook:- " + sLinks[0].Facebook);
        // console.log("Twitter:- " + sLinks[1].Twitter);
        // console.log("GooglePlus:- " + sLinks[2].GooglePlus);
        //console.log("LinkedIn:- " + sLinks[3].LinkedIn);
        $("#spnFacebook").hide();
        $("#spnTwitter").hide();
        $("#spnLinkedIn").hide();
        console.log(self.attendeeData[0].SocialLinks);
        //debugger;
        var showFB = 0;
        var showTwitter = 0;
        var showLinkedIn = 0;

        self.attendeeData[0].SocialLinks.forEach((sLink) => {
          if (sLink["Facebook"] != undefined) {
            if (sLink["Facebook"] != "") {
              showFB++;
              if (sLink["Facebook"].includes("https://")) {
                document.getElementById("anchFacebook").href =
                  sLink["Facebook"];
              } else {
                document.getElementById("anchFacebook").href =
                  "https://" + sLink["Facebook"];
              }
            }
          }

          if (sLink["Twitter"] != undefined) {
            if (sLink["Twitter"] != "") {
              showTwitter++;
              if (sLink["Twitter"].includes("https://")) {
                document.getElementById("anchTwitter").href = sLink["Twitter"];
              } else {
                document.getElementById("anchTwitter").href =
                  "https://" + sLink["Twitter"];
              }
            }
          }

          if (sLink["LinkedIn"] != undefined) {
            if (sLink["LinkedIn"] != "") {
              showLinkedIn++;
              if (sLink["LinkedIn"].includes("https://")) {
                document.getElementById("anchLinkedIn").href =
                  sLink["LinkedIn"];
              } else {
                document.getElementById("anchLinkedIn").href =
                  "https://" + sLink["LinkedIn"];
              }
            }
          }
        });
        if (showFB > 0) {
          $("#spnFacebook").show();
        }
        if (showTwitter > 0) {
          $("#spnTwitter").show();
        }
        if (showLinkedIn > 0) {
          $("#spnLinkedIn").show();
        }

        //---------------------------------------------------------------------------------------------
      });

      // console.log(Name);
      // console.log(Company);
      // console.log(Title);
      // console.log(Image);
      // console.log(profile);
      // console.log(Initials);
      // console.log(sLinks);
      // console.log(Resources);

      // $("#myModal2").addClass("show");
      // $("#myModal2").show();
      // $("#dvBackDrop").show();
      // $("#dvBackDrop").addClass("show");
    },
    //getInitials: function (str) {
    //  // alert(str);
    //  //var str = "Java Script Object Notation";
    //  var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
    //  var acronym = matches.join(""); // JSON
    //  return acronym;
    //  //console.log(acronym);
    //},
    getCalendarDateTime: function (s, option) {
      //debugger;
      var dt = new Date(s * 1000);

      var day = dt.getDate();
      var month = dt.getMonth() + 1;
      var year = dt.getFullYear();
      if (month < 10) {
        month = "0" + month.toString();
      }
      if (day < 10) {
        day = "0" + day.toString();
      }
      var hours = dt.getHours();
      if (hours < 10) {
        hours = "0" + hours.toString();
      }
      var minutes = dt.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes.toString();
      }
      var seconds = dt.getSeconds();
      if (seconds < 10) {
        seconds = "0" + seconds.toString();
      }
      //var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      //hours = hours > 12 ? hours - 12 : hours;
      //hours = hours == 0 ? 12 : hours;
      //minutes = minutes == 0 ? "00" : minutes > 9 ? minutes : "0" + minutes;
      //seconds = seconds == 0 ? "00" : seconds > 9 ? seconds : "0" + seconds;
      var formattedValue = "";
      if (option == "google") {
        formattedValue =
          year.toString() +
          month.toString() +
          day.toString() +
          "T" +
          hours.toString() +
          minutes.toString() +
          seconds.toString();
      } else if (option == "outlook") {
        //formattedValue =
        //  year.toString() +
        //  "-" +
        //  month.toString() +
        //  "-" +
        //  day.toString() +
        //  "T" +
        //  hours.toString() +
        //  ":" +
        //  minutes.toString() +
        //  ":" +
        //  seconds.toString();
        //12%2F18%2F2020+11%3A00+AM
        //alert(hours);
        //alert(minutes);
        formattedValue =
          year.toString() +
          "%2F" +
          month.toString() +
          "%2F" +
          day.toString() +
          "+";

        if (hours < 10) {
          formattedValue += hours.toString() + "%3A";
        } else {
          if (hours <= 12) {
            formattedValue += hours.toString() + "%3A";
          } else {
            formattedValue += (hours - 12).toString() + "%3A";
          }
        }

        if (minutes < 10) {
          formattedValue += minutes.toString() + "+";
        } else {
          formattedValue += minutes.toString() + "+";
        }

        if (hours < 12) {
          formattedValue += "AM";
        } else {
          formattedValue += "PM";
        }
        //"+" +
        //  "10" + //hours.toString() +
        //  "%3A" +
        //  "10+AM"; //minutes.toString();
        //alert(formattedValue);
      }
      return formattedValue;
    },
    getFileName(downloadUrl) {
      let url = decodeURIComponent(downloadUrl);
      let arr = url.split("?");
      let arr2 = arr[0].split("/");
      let name = arr2[arr2.length - 1];
      return name;
    },
  },
};
</script>